// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"3016b08e","328":"3016b08e"}[chunkId] + ".chunk.css";
};